// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"271":"7fa53f8c","654":"55efe355","662":"debdf870","727":"670fcecc","787":"cda612ba"}[chunkId] + ".chunk.js";
};